import { useEffect, useState } from 'react';

import * as signalR from '@microsoft/signalr';

import Utils from '../Assets/Scripts/Utils';

const useSignalR = (hubName) => {
  const [connection, setConnection] = useState(null);

  useEffect(() => {
    const newConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${process.env.REACT_APP_HOST}/hubs/${hubName}`, {
        accessTokenFactory: () => localStorage.getItem('conecta__token'),
      })
      .withAutomaticReconnect()
      .build();

    setConnection(newConnection);
  }, []);

  useEffect(() => {
    if (connection) {
      connection.start().catch((err) => Utils.logError(err));
    }

    return () => {
      if (connection) {
        connection.stop();
      }
    };
  }, [connection]);

  return connection;
};

export default useSignalR;
